import React, { useEffect } from "react";
import CreatePostPage from "../../CreatePostPage";

// Posting to a league, in a modal over the league.
//
// The editor inside is the app's real post editor (CreatePostPage in embedded
// mode) — same rich text, same media upload, same lock rules, same createPost
// call with this league's game_id. Forking it into a modal-only editor would mean
// two posting paths to keep in step, and one of them would rot.
const LeaguePostModal = ({ open, game, onClose, onPosted }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previous;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end md:items-center justify-center bg-black/50 md:p-6"
      role="dialog"
      aria-modal="true"
      aria-label={`Post to ${game?.title || "your league"}`}
      onClick={onClose}
    >
      <div
        className="w-full md:max-w-2xl max-h-[92vh] md:max-h-[88vh] overflow-y-auto bg-white rounded-t-3xl md:rounded-2xl shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Client Rev 3, desktop private league: "Remove the redundant part at the
            top of the composer modal that i circled in blue. then we can move the
            x close out down inline with the username right aligned. Composer will
            shrink in height."
            What was here was a sticky bar reading "New Post" over "Posting to
            <league title>" — and the editor below already opens with the member's
            avatar, their username, and the SAME "Posting to <league title>" line.
            So the modal said where the post was going twice, one line apart.
            The bar is gone and `onClose` goes down to the editor, which renders the
            X on the username row (see CreatePostPage). The panel loses ~62px of
            height, which is the "Composer will shrink in height" part. */}
        <CreatePostPage
          embedded
          gameId={game?.id}
          slug={game?.vanity_url}
          onClose={onClose}
          onDone={() => {
            onPosted?.();
            onClose?.();
          }}
        />
      </div>
    </div>
  );
};

export default LeaguePostModal;
